module.exports = __webpack_public_path__ + "static/media/Hotel Nirvana.6462198f.png";